
import front from '@/../static/js/proto/CtpFront';
import * as format from '@/utils/format';

export const con_operation = [
  {
    text: '>=',
    value: front.con_operation_ge,
  },
  {
    text: '<',
    value: front.con_operation_lt,
  },
  {
    text: '>',
    value: front.con_operation_gt,
  },
  {
    text: '<=',
    value: front.con_operation_le,
  },
];
export const offset = [
  {
    text: '开',
    value: front.offset_open,
  },
  {
    text: '平',
    value: front.offset_close,
  },
];

export const direct = [
  {
    text: '买',
    value: front.direct_buy,
    cls: {
      background: '#ee3f44',
    },
  },
  {
    text: '卖',
    value: front.direct_sell,
    cls: {
      background: '#409f5f',
    },
  },
];

export const validTime = [
  {
    text: '当前交易日',
    value: front.con_validity_gfd,
  },
  {
    text: '永久有效',
    value: front.con_validity_all,
  },
];

export function con_active_state() {
  return  [
  {
    text: '运行中',
    value: front.con_order_run,
  },
  {
    text: '暂停',
    value: front.con_order_stop,
  },
  {
    text: '已触发',
    value: front.con_order_trigger,
  },
  {
    text: '已删除',
    value: front.con_order_delete,
  },
  {
    text: '已结算',
    value: front.con_order_settlement,
  },
];
}
/**
 * 报单类型
 */
export const con = [
  {
    text: '限价',
    value: front.con_limit_price,
  },
  {
    text: '对手价',
    value: front.con_opponent_price,
  },
  {
    text: '最新价',
    value: front.con_last_price,
  },
  {
    text: '市价',
    value: front.con_market_price,
  },
  {
    text: '超一价',
    value: front.con_plusone_tick_price,
  },
];

export function getText(arr: Array<{ text: string; value; }>, value) {
  const find = arr.filter(r => r.value === value);
  if (find && find.length) {
    return find[0].text;
  }
  return '';
}

export function getOrder(item: IOrderConditional) {
  let ret = '';
  ret += getText(direct, item.direction);
  ret += getText(offset, item.offset);
  ret += ',';
  if (item.orderPriceType === front.con_limit_price) {
    ret += format.toDoubleDigits(item.orderPrice);
  } else {
    ret += getText(con, item.orderPriceType);
  }
  ret += ',';
  ret += item.volume + '手';
  return ret;
}
export function getCondition(item: IOrderConditional) {
  // return getText(con_operation, item.operationType)
  //   + ' ' + format.toDoubleDigits(item.price);
  if (item.orderType === 0) {
    return getText(con_operation, item.operationType)
      + ' ' + item.price;
  } else if (item.orderType === 1) {
    const obj = {
      sl: '>' + ' ' + item.slPrice,
      tp: '<' + ' ' + item.tpPrice,
    };
    return obj;
  }
}
export function getConditions(item: IOrderConditional) {
  if (item.orderType === 0) {
    return getText(con_operation, item.operationType)
      + ' ' + item.price;
  } else if (item.orderType === 1) {
    const obj = {
      sl: '<' + ' ' + item.slPrice,
      tp: '>' + ' ' + item.tpPrice,
    };
    return obj;
  }
}

export function getState(item: IOrderConditional) {
  return getText(con_active_state(), item.state);
}



// WEBPACK FOOTER //
// ./src/views/condition/ConditionData.ts